import React from 'react';
import { useMediaQuery } from 'react-responsive';
import sanitize from 'sanitize-html';
import { RootState } from '@Redux/search/store';
import { useSelector } from 'react-redux';

export const TableContent: React.FC<{
    title: string;
    content: string;
    customTableColSize?: string;
}> = ({ title, content, customTableColSize }) => {
    const isPc = useMediaQuery({ query: '(min-width: 980px)' });
    const { curPage } = useSelector((state: RootState) => state.pageReducer);
    const isPrint = curPage === 'print';
    const sanitizedContent = (
        <div
            dangerouslySetInnerHTML={{
                __html: sanitize(content, {
                    allowedTags: false,
                    allowedAttributes: false,
                }),
            }}
        />
    );

    const fullContent = (
        <>
            {title.length > 0 && <div className="title">{title}</div>}
            {content ? sanitizedContent : <div>--</div>}
        </>
    );

    return customTableColSize ? (
        <div
            className="customContentColumn"
            style={isPc || isPrint ? { width: customTableColSize } : {}}
        >
            {fullContent}
        </div>
    ) : (
        fullContent
    );
};
